import React from 'react'
import PropTypes from "prop-types"
import { Button as RBButton, Glyphicon, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { omit, isString } from 'lodash'

const Button = (props) => {
  const button = (
    <RBButton
      bsSize={props.bsSize || "small"}
      {...omit(props, ["glyph", "children", "tooltipText"])}
    >
      {props.glyph ? (<span><Glyphicon glyph={props.glyph} /> </span>) : ""}
      {props.label}
      {props.children || ""}
    </RBButton>
  )

  if (props.tooltipText) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip
            style={{ fontSize: 15 }}
            id={props.tooltipText}
          >
            {props.tooltipText}
          </Tooltip>
        }
      >
        {button}
      </OverlayTrigger>
    )
  }

  return button
}

const requiredStringForIconButtons = (props, propName, componentName) => {
  const v = props[propName]
  if (!props.label && !props.children && !v) {
    return new Error(`Prop "${propName}" on "${componentName}" is mandatory if there are no children or label (just-icon buttons)`)
  }
  else if ((v && !isString(v)) || v === "") {
    return new Error(`Prop "${propName}" on "${componentName}" must be a non-empty string`)
  }
  else return null
}

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  glyph: PropTypes.string,
  bsSize: PropTypes.string,
  label: PropTypes.string,

  tooltipText: requiredStringForIconButtons,
}

Button.defaultProps = {
  glyph: "",
  tooltipText: "",
  bsSize: "small",
  children: "",
  label: null,
}

export default Button



// WEBPACK FOOTER //
// ./src/app/admin/components/Button.jsx